import 'antd/dist/antd.css';

import {
  Button,
  Card,
  CascaderSelect,
  DatePicker,
  Dialog,
  Form,
  Input,
  Message,
  Pagination,
  Table,
} from '@alifd/next';
import { Image } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

import ezconImg from '../../../../../public/ezcon.png';
import client from '../../../../lib/feathers';
import { filterVisitorAppointmentList } from './helpers';
import styles from './index.module.scss';
import LeftVisitorDetail from './LeftVisitorDetail';

const VisitorAccessStatisticsList = () => {
  const { RangePicker } = DatePicker;
  const visitorAppointmentRegistration = client.service(
    'visitorAppointmentRegistration'
  );
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const cardManagement = client.service('cardManagement');
  const user = useSelector((state) => state.user);
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );

  const [visitorAppointmentArr, setVisitorAppointmentArr] = useState([]);
  const [visitorAppointmentAllArr, setVisitorAppointmentAllArr] = useState([]);
  const [visitorsName, setVisitorsName] = useState('');
  const [visitorsPhone, setVisitorsPhone] = useState('');
  const [householdNumber, setHouseholdNumber] = useState(''); // 戶號
  // const [intervieweeName, setIntervieweeName] = useState('');
  const [intervieweeRemarks, setIntervieweeRemarks] = useState('');
  const [visitingReason, setVisitingReason] = useState('');
  const [peopleNumber, setPeopleNumber] = useState(1);
  const [takeCardStatus, setTakeCardStatus] = useState(''); // 取卡狀態
  const [visitorDetailDialog, setVisitorDetailDialog] = useState(false);
  const [visitorDetailIndex, setVisitorDetailIndex] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [visitorPhoto, setVisitorPhoto] = useState(null);
  const [cardStatus, setCardStatus] = useState(false);
  const [cardNumbering, setCardNumbering] = useState('');
  const [cardNotes, setCardNotes] = useState('');
  // 搜尋
  // const [foundArr, setFoundArr] = useState(null);
  const [searchVisitorName, setSearchVisitorName] = useState('');
  const [searchHouseholdNumber, setSearchHouseholdNumber] = useState('');
  const [dateStart, setDateStart] = useState('');
  const [dateEnd, setDateEnd] = useState('');
  const [curdataIndex, setcurDataIndex] = useState('leaveTime');
  const [curorder, setcurOrder] = useState('desc');

  // 顯示詳細資訊
  const [showLeftVisitorDetail, setShowLeftVisitorDetail] = useState(false);
  const [leftVisitorDetail, setLeftVisitorDetail] = useState({});

  // card
  const [cardArr, setCardArr] = useState([]);
  // console.log(cardArr)
  // residentAccountNumbers
  async function funFindResident(para) {
    const result = await residentAccountNumbers.find({ query: para });
    return result && result.data ? result.data : [];
  }

  // 抓取redux useradmin 資料
  const [allowedFuncs, setAllowedFuncs] = useState([]);
  useEffect(() => {
    if (user.adminUserGroup.key) {
      setAllowedFuncs(user.adminUserGroup.key.checkedKeys);
    }
  }, [user]);

  function householdNumberSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && parseInt(a.floor) > parseInt(b.floor)
      ? 1
      : -1 && parseInt(a.floorChild) > parseInt(b.floorChild)
      ? 1
      : -1;
  }

  function serverResidentDataUpdate() {
    funFindResident({}).then((result) => {
      setResidentAccountNumbersArr(result.sort(householdNumberSort));
    });
  }
  useEffect(() => {
    serverResidentDataUpdate();
  }, []);

  // visitorArr

  async function funFindVisitor() {
    const result = await visitorAppointmentRegistration.find({
      query: {
        visitorsStatus: {
          $nin: ['已取消', '預約中', '審核中', '已入場'],
        },
      },
    });
    console.log(result);
    return result && result.data ? result.data : [];
  }
  async function funUpdateVisitor(id, obj) {
    await visitorAppointmentRegistration.patch(id, obj);
  }

  const serverVisitorDataUpdate = () => {
    funFindVisitor().then((result) => {
      console.log(result);
      setVisitorAppointmentArr(result);
      setVisitorAppointmentAllArr(result);
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverVisitorDataUpdate(dataIndex, order);
  };
  useEffect(() => {
    serverVisitorDataUpdate();
  }, []);

  // card
  async function funFindCard() {
    const result = await cardManagement.find({
      query: {
        cardNumber,
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funUpdateCard(id, obj) {
    await cardManagement.patch(id, obj);
  }

  function serverCardDataUpdate() {
    funFindCard().then((result) => {
      setCardArr(result);
    });
  }
  useEffect(() => {
    serverCardDataUpdate();
  }, [cardNumber]);
  // 戶號選單
  function ParseStringToArrayObject() {
    // 戶號拆解
    const data = residentAccountNumbersArr.map((i) =>
      i.householdNumber.split('-')
    );
    let Stages = [];
    function iter(e, si = 1) {
      const va = e.slice(0, si).join('-');
      if (!Stages.includes(va)) Stages.push(va);
      if (e[si]) iter(e, si + 1);
    }
    data.forEach((e) => {
      iter(e);
    });
    Stages = Stages.sort((a, b) => {
      return a.length - b.length;
    });
    const newStages = {};
    Stages.forEach((e) => {
      // (e.length==1)newStages[e] = [e];
      if (e.indexOf('-') === -1) newStages[e] = [e];
      else {
        const theDashNb = e.indexOf('-');
        // newStages[e.slice(0,1)].push(e);
        newStages[e.slice(0, theDashNb)].push(e);
      }
    });
    const FinalData = [];
    Object.keys(newStages).forEach((e) => {
      // { A:['A','A-1'],B:['B','B-1','B-1-1']...}
      const childsObj = {};
      newStages[e].forEach((ee) => {
        let tempTarLabel = ee;
        if (ee.indexOf('-') >= 0) {
          const tempArrChild = ee.split('-');
          tempTarLabel = tempArrChild[tempArrChild.length - 1];
        }
        childsObj[ee] = {
          // 'label': ee.indexOf("-")==-1? ee : ee.slice(ee.length-1,ee.length),
          label: tempTarLabel,
          value: ee,
        };
      });
      newStages[e].reverse().forEach((ee) => {
        // 底層開始 => 加入到上一層children
        // if(ee.length>=3){
        if (ee.indexOf('-') != -1) {
          const tempArrChild = ee.split('-');
          // const ky = ee.slice(0,ee.length-2);
          const ky = tempArrChild.slice(0, tempArrChild.length - 1).join('-');
          if (!childsObj[ky].children) {
            // 加入到上一層children
            childsObj[ky].children = [childsObj[ee]];
          } else {
            childsObj[ky].children.push(childsObj[ee]);
            childsObj[ky].children.sort((a, b) => {
              return a.label - b.label;
            }); // label小－大
          }
        }
      });
      FinalData.push(childsObj[Object.keys(childsObj)[0]]); // 只取最上層(第一比obj)(資料已經都加到第一比)
    });
    return FinalData;
  }

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;

  const getVisitorAppointmentList = useCallback(() => {
    const filteredVisitorAppointments = filterVisitorAppointmentList({
      visitorAppointmentArr,
      searchVisitorName,
      searchHouseholdNumber,
      dateStart,
      dateEnd,
    });

    setCurrentPage(1);
    return filteredVisitorAppointments;
  }, [
    dateEnd,
    dateStart,
    searchHouseholdNumber,
    searchVisitorName,
    visitorAppointmentArr,
  ]);

  const visitorAppointmentList = useMemo(() => {
    const visitorAppointmentList = getVisitorAppointmentList();
    return visitorAppointmentList;
  }, [getVisitorAppointmentList]);

  const currentPosts = visitorAppointmentList.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  return (
    <>
      <div className={styles.visitorSearchBox}>
        <h2>訪客名稱</h2>
        <Input
          hasClear
          className={styles.visitorText}
          placeholder="請輸入訪客姓名"
          onChange={(value) => {
            setSearchVisitorName(value);
          }}
        />
        <h2 className={styles.visitorText}>受訪人戶號</h2>
        <CascaderSelect
          hasClear
          className={styles.visitorText}
          placeholder="請選擇戶號"
          dataSource={ParseStringToArrayObject()}
          onChange={(value) => setSearchHouseholdNumber(value)}
        />
      </div>
      <div className={styles.visitorSearchTimeBox}>
        <h2>日期</h2>
        <RangePicker
          className={styles.visitorTextTime}
          onChange={(value) => {
            setDateStart(value[0]);
            setDateEnd(value[1]);
          }}
          onOk={(value) => {
            // if(value[0]===value[1]){
            //   Message.error("請務必選擇起始日期即結束日期")
            //   return;
            // }
            // console.log(value)
          }}
        />
      </div>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={visitorDetailDialog}
        footerActions={['ok']}
        onOk={() => {
          setVisitorDetailDialog(false);
        }}
        onCancel={() => {
          setVisitorDetailDialog(false);
        }}
        onClose={() => {
          setVisitorDetailDialog(false);
        }}
      >
        <h2>訪客資訊</h2>
        <div className={styles.detailPhoto}>
          <Form.Item className={styles.detailTitle} label="訪客姓名">
            {visitorsName}
          </Form.Item>
          {/* <img
            className={styles.photo}
            src={
              visitorPhoto
                ? visitorPhoto
                : 'https://i.ibb.co/LZRgfyg/2021-02-01-5-48-52.png'
            }
            alt="訪客照片"
          ></img> */}
          <Image
            className={styles.photo}
            src={visitorPhoto || ezconImg}
            alt="訪客照片"
          />
        </div>
        <Form.Item className={styles.detailTitle} label="訪客電話">
          {visitorsPhone}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="人數">
          {peopleNumber}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="拜訪原因">
          {visitingReason}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="受訪人戶號">
          {householdNumber}
        </Form.Item>
        {/* <Form.Item className={styles.detailTitle} label="受訪人姓名">
                    {intervieweeName}
                  </Form.Item> */}
        <Form.Item className={styles.detailTitle} label="備註">
          {intervieweeRemarks}
        </Form.Item>
        {/* <Form.Item className={styles.detailTitle} label="卡片流水號">
          {cardOrderNumber}
        </Form.Item> */}
        <Form.Item className={styles.detailTitle} label="卡片編號">
          {cardNumbering}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="卡片備註">
          {cardNotes}
        </Form.Item>
        <Form.Item className={styles.detailTitle} label="訪客卡狀態">
          {cardStatus === true ? '已還卡' : takeCardStatus}
          {takeCardStatus === '遺失' ? (
            <Button
              disabled={cardStatus === true}
              className={styles.detailTitleBtn}
              type="secondary"
              onClick={() => {
                const cardItem = cardArr[0];
                cardItem.cardStatus = '未使用';
                const item = currentPosts[visitorDetailIndex];
                item.takeCardLost = '否';
                item.takeCardStatus = '已還卡';
                funUpdateVisitor(item._id, item).then(() => {
                  serverVisitorDataUpdate();
                });
                funUpdateCard(cardItem._id, cardItem).then(() => {
                  Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: '還卡成功',
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  serverCardDataUpdate();
                });

                setCardStatus(true);
              }}
            >
              已還卡
            </Button>
          ) : (
            ''
          )}
        </Form.Item>
      </Dialog>
      {/* 20220317 移除拜訪原因 & 訪客狀態 & 是否遺失訪客卡 */}
      {/* 20220317 修改來訪時間判斷 & 詳細資料顯示方式 */}
      {/* 20220318 增加排序篩選器 */}
      <Card free>
        <Card.Content>
          <Table dataSource={currentPosts} onSort={onTableSort}>
            <Table.Column
              title="來訪時間"
              width={200}
              cell={(
                _value,
                _index,
                { admissionTime, carEntryTime, faceEntryTime, visitorsStatus }
              ) => {
                if (visitorsStatus !== '已拒絕') {
                  const times = [];
                  if (admissionTime) {
                    times.push(new Date(admissionTime));
                  }
                  if (carEntryTime) {
                    times.push(carEntryTime);
                  }
                  if (faceEntryTime) {
                    times.push(faceEntryTime);
                  }
                  const earliestTime = Math.min(...times);
                  return moment(earliestTime).format('YYYY-MM-DD HH:mm:ss');
                } else {
                  return '未進場';
                }
              }}
            />
            <Table.Column
              title="離開時間"
              dataIndex="leaveTime"
              width={200}
              cell={(value, _index, record) =>
                record.visitorsStatus === '已拒絕' ? '未進場' : value
              }
            />
            <Table.Column
              title="狀態"
              dataIndex="visitorsStatus"
              width={200}
              sortable
            />
            <Table.Column
              title="訪客卡號"
              dataIndex={
                allowedFuncs.includes('訪客卡片管理')
                  ? 'cardNumber'
                  : 'cardOrderNumber'
              }
              width={200}
              sortable
            />
            <Table.Column
              title="訪客姓名"
              dataIndex="visitorsName"
              width={150}
              sortable
            />
            <Table.Column
              title="戶號"
              dataIndex="householdNumber"
              width={150}
              sortable
            />
            <Table.Column
              title="人數"
              dataIndex="peopleNumber"
              width={100}
              sortable
            />
            <Table.Column
              title="訪客卡狀態"
              dataIndex="takeCardStatus"
              width={150}
              sortable
            />
            <Table.Column
              title="操作"
              lock="right"
              width={150}
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);
                return (
                  <div>
                    <Button
                      type="secondary"
                      onClick={() => {
                        setCardNumber(currentPosts[index].cardNumber);
                        setVisitorsName(currentPosts[index].visitorsName);
                        setVisitorsPhone(currentPosts[index].visitorsPhone);
                        setPeopleNumber(currentPosts[index].peopleNumber);
                        setVisitingReason(currentPosts[index].visitingReason);
                        setHouseholdNumber(currentPosts[index].householdNumber);
                        setIntervieweeRemarks(
                          currentPosts[index].intervieweeRemarks
                        );
                        setVisitorPhoto(currentPosts[index].visitorPhoto);
                        setTakeCardStatus(currentPosts[index].takeCardStatus);
                        setCardNumbering(currentPosts[index].cardNumbering);
                        setCardNotes(currentPosts[index].cardNotes);

                        setShowLeftVisitorDetail(true);
                        setLeftVisitorDetail(record);
                      }}
                    >
                      詳細
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
          {/* 詳細資訊 Dialog */}
          <Dialog
            hasMask
            title="訪客資料"
            visible={showLeftVisitorDetail}
            onClose={() => setShowLeftVisitorDetail(false)}
            onCancel={() => setShowLeftVisitorDetail(false)}
            footer={
              <Button
                type="normal"
                onClick={() => setShowLeftVisitorDetail(false)}
              >
                關閉
              </Button>
            }
          >
            <LeftVisitorDetail
              detail={leftVisitorDetail}
              allowedFuncs={allowedFuncs}
            />
          </Dialog>
          <Pagination
            className={styles.pagination}
            total={visitorAppointmentList.length}
            current={currentPage}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default VisitorAccessStatisticsList;
